module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/flag-7e2e350a8848260562799f693eb452f2.svg";